import Api from "../service/api";
import { interact, URLS } from "fire-wind-water";
import WX from "../utils/wx";
const successMixin = {
  created() {
    this.module = window.$sk.template.module(this);
  },
  beforeDestroy() {
    this.module.unsubscribe();
  },
  methods: {
    skUserEnd() {
      console.log("获取用户信息结束");
      const info = window.$sk.template.get();
      this.tenantId = info.common.tenantId;
      this.instanceId = info.common.instanceId;
      this.sess = info.user.session;
      this.globalUserId = info.user.globalUserId;
      this.contactInfo = info.user;

      const id = URLS.getURL("configId") || URLS.getHash("configId");
      this.initConfig(id, this.tenantId);
      if (this.isSetting) {
        return;
      }
      this.questionnaireGet();
    },
    questionnaireGet() {
      Api.getQuestionnaire({
        tenantId: this.tenantId,
        questionnaireId: this.questionnaireId,
      }).subscribe((data) => {
        if (data.content) {
          this.hasJoin = Number(data.content.isReSubmit);
        }
        if (interact.isWeChat) {
          WX.initWeChatShare(data.content);
        }
      });
    },
    goIndex() {
      this.$router.push({ path: "index" });
    },
  },
};
export default successMixin;
